
import SIcon from 'SharedComponents/ui/Icon/SIcon.vue';
import { SignerInfo } from 'SharedDir/declarations/crypto-pro';
import { computed, defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'Signer',
  components: { SIcon },
  props: {
    signer: { type: Object as PropType<SignerInfo>, required: true },
  },
  setup(props) {
    function date(value: string | Date) {
      if (!(value instanceof Date)) {
        value = new Date(value);
      }
      return value.toLocaleString();
    }
    return {
      date,
    };
  },
});
